// extracted by mini-css-extract-plugin
export default {"root":"TaCeO75D"};